import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import AssignmentTemplateHeader from './AssignmentTemplateHeader';

const Index = () => {
  const fetchAssignmentTemplate = async () => {
    const res = await axios.get(API_URL + '/assignment-template');
    return res;
  };
  const { status, data } = useQuery('fetchAssignmentTemplate', fetchAssignmentTemplate);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <Box>
          <AssignmentTemplateHeader data={data.data.data} />{' '}
        </Box>
      )}
    </div>
  );
};

export default Index;
